import NoGiftsIcon from "@/assets/icons/no-gifts-inventory-icon.svg?react"

import { getGiftRelayBotHandle } from "../lib/relayBot"

interface GiftsEmptyHintProps {
  /** Localized message containing the relay-bot `{handle}` placeholder. */
  text: string
  /** Tapping the handle opens the relay-bot chat. */
  onHandleClick?: () => void
}

/**
 * Centered "no gifts" hint: gift icon + message with the relay-bot handle
 * rendered as a green link. Shared by the gifts deposit/withdraw sheets.
 */
export function GiftsEmptyHint({ text, onHandleClick }: GiftsEmptyHintProps) {
  const handle = getGiftRelayBotHandle()
  const resolved = text.replace("{handle}", handle)
  const idx = resolved.indexOf(handle)
  const before = idx === -1 ? resolved : resolved.slice(0, idx)
  const after = idx === -1 ? "" : resolved.slice(idx + handle.length)

  return (
    <div className="flex w-full flex-col items-center gap-4 px-8 text-center">
      <NoGiftsIcon className="size-[60px] text-white" />
      <p className="max-w-[326px] text-[16px] font-medium leading-[19px] tracking-[-0.5px] text-white">
        {before}
        <button
          type="button"
          onClick={onHandleClick}
          className="text-[#00FE74] hover:underline focus:outline-none"
        >
          {handle}
        </button>
        {after}
      </p>
    </div>
  )
}
